import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', background: '#12151A', color: '#F0EDE4', padding: 24, fontFamily: 'monospace' }}>
          <h2 style={{ color: '#D02127' }}>Terjadi Kesalahan</h2>
          <p style={{ color: '#8B92A0', marginBottom: 16 }}>
            Ada error saat menampilkan halaman ini. Screenshot ini dan kirim ke admin:
          </p>
          <pre style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 16, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12, color: '#D02127' }}>
            {String(this.state.error)}
            {'\n\n'}
            {this.state.info?.componentStack}
          </pre>
          <button
            onClick={() => (window.location.href = '/login')}
            style={{ marginTop: 20, background: '#2B6996', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 6, fontWeight: 'bold', cursor: 'pointer' }}
          >
            Kembali ke Login
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
